/* =========================================================
   MO · ENTRADA DE SECCIONES AL HACER SCROLL
   Una sola vez · Móvil + Escritorio
   ========================================================= */

(function () {

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );


  /* =======================================================
     QUÉ SECCIONES VAN A TENER EL EFECTO
     ======================================================= */

  const selectors = [

    /* TODAS LAS SECCIONES MO */
    '[class^="mo-"]',
    '[class*=" mo-"]',

    /* SHOPIFY · COLLAGE DE IMÁGENES */
    '.image-collage',

    /* SHOPIFY · BOLETÍN / NEWSLETTER */
    '.newsletter',
    '.newsletter-section',
    '.newsletter__wrapper'

  ];


  let observer = null;


  /* =======================================================
     COMPROBAR SI UNA SECCIÓN DEBE ANIMARSE
     ======================================================= */

  function sectionIsIncluded(shopifySection) {

    if (!shopifySection) return false;

    return shopifySection.querySelector(
      selectors.join(',')
    ) !== null;

  }


  /* =======================================================
     CREAR OBSERVADOR
     ======================================================= */

  function createObserver() {

    if (observer) {
      observer.disconnect();
    }

    observer = new IntersectionObserver(

      function (entries) {

        entries.forEach(function (entry) {

          if (!entry.isIntersecting) return;

          const section = entry.target;

          section.classList.add(
            'mo-scroll-reveal-visible'
          );


          /*
            IMPORTANTE:
            Una vez hecha la animación,
            dejamos de observar esta sección.

            Por tanto NO se vuelve a repetir.
          */

          observer.unobserve(section);

        });

      },

      {
        threshold: 0.18
      }

    );

  }


  /* =======================================================
     PREPARAR CADA SECCIÓN
     ======================================================= */

  function prepareSection(shopifySection) {

    if (!shopifySection) return;

    if (reducedMotion.matches) {
      return;
    }


    /*
      Solo actuamos sobre:
      - secciones MO
      - collage Shopify
      - newsletter Shopify
    */

    if (!sectionIsIncluded(shopifySection)) {
      return;
    }


    /*
      Evitar inicializar dos veces
      la misma sección
    */

    if (
      shopifySection.dataset.moScrollReveal === 'true'
    ) {
      return;
    }


    shopifySection.dataset.moScrollReveal = 'true';


    /*
      IMPORTANTE:
      Aplicamos el movimiento al contenedor exterior
      .shopify-section.

      Así no interferimos con animaciones internas,
      sliders, cambios de color, etc.
    */

    shopifySection.classList.add(
      'mo-scroll-reveal'
    );


    observer.observe(shopifySection);

  }


  /* =======================================================
     INICIALIZAR TODA LA PÁGINA
     ======================================================= */

  function initMoScrollReveal() {

    if (reducedMotion.matches) {
      return;
    }


    createObserver();


    const sections = document.querySelectorAll(
      '.shopify-section'
    );


    sections.forEach(function (section) {

      prepareSection(section);

    });

  }


  /* =======================================================
     CARGA NORMAL DE LA WEB
     ======================================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initMoScrollReveal
    );

  } else {

    initMoScrollReveal();

  }


  /* =======================================================
     EDITOR DE SHOPIFY
     Si Shopify recarga una sección
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (reducedMotion.matches) {
        return;
      }


      if (!observer) {
        createObserver();
      }


      prepareSection(event.target);

    }
  );

})();